import { Editor, Transforms, Element } from 'slate';
import { getCurrentNode } from '../lib/queries';
import { isList } from '../plugins/list/listType';

export const enterKeyDownHandler = (e: React.KeyboardEvent, editor: Editor) => {
  const { selection } = editor;
  if (selection && selection !== null) {
    const node = getCurrentNode(editor);
    // Don't add line breaks in element lists, allow default behaviour instead
    if (Element.isElement(node) && Element.isElementList(node.children)) {
      if (!isList(node)) {
        Editor.insertBreak(editor);
      }
      return;
    }

    if (e.shiftKey) {
      Transforms.insertFragment(editor, [
        {
          text: '\n',
        },
      ]);
    } else if (Editor.isEnd(editor, selection.anchor, selection.anchor.path)) {
      // if we're hitting return at the end of the block
      // append default node
      Transforms.insertNodes(editor, [
        {
          children: [
            {
              text: '',
            },
          ],
        },
      ]);
      // if we're hitting return at the beginning of the block
    } else if (
      Editor.isStart(editor, selection.anchor, selection.anchor.path)
    ) {
      // prepend default node
      Transforms.insertNodes(
        editor,
        [
          {
            children: [
              {
                text: '',
              },
            ],
          },
        ],
        {
          at: [selection.anchor.path[0]],
        },
      );
      // anywhere else
    } else {
      // split the node
      Transforms.splitNodes(editor);
      // and update the split node to have the default type
      Transforms.setNodes(editor, {
        type: undefined,
      });
    }
  }
};
